import React from 'react'
import { useLocation } from 'react-router-dom'
import { Bell } from 'lucide-react'

const VendorHeader = ({
  sidebarItems,
  companyName,
  contactPersonProfile,
  onProfileClick
}) => {
  const location = useLocation()
  
  const getActiveTab = () => {
    const path = location.pathname
    if (path.includes('/bench-resources')) return 'bench-resources'
    if (path.includes('/purchase-orders')) return 'purchase-orders'
    if (path.includes('/interviews')) return 'interviews'
    if (path.includes('/placements')) return 'placements'
    if (path.includes('/subscription')) return 'subscription'
    if (path.includes('/payments')) return 'payments'
    if (path.includes('/settings')) return 'settings'
    return 'overview'
  }
  
  const activeTab = getActiveTab()
  const currentTabName = sidebarItems.find(item => item.id === activeTab)?.name || 'Dashboard'

  return (
    <div className="bg-white dark:bg-secondary-800 shadow-sm border-b border-secondary-200 dark:border-secondary-700">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-secondary-900 dark:text-secondary-100">
              {currentTabName}
            </h2>
            <p className="text-sm text-secondary-600 dark:text-secondary-400">
              {companyName}
            </p>
          </div>
          
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <Bell className="w-5 h-5 text-secondary-400 dark:text-secondary-500" />
              <div
                className="h-8 w-8 bg-primary-100 dark:bg-primary-900/30 rounded-full flex items-center justify-center cursor-pointer hover:bg-primary-200 dark:hover:bg-primary-900/50 transition-colors shadow-sm"
                onClick={onProfileClick}
                title="View Profile"
              >
                <span className="text-sm font-semibold text-primary-600 dark:text-primary-400">
                  {contactPersonProfile?.contact_name?.charAt(0) || 
                   contactPersonProfile?.name?.charAt(0) || 
                   companyName?.charAt(0) || 'U'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VendorHeader

